import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
export async function getCampaignInsights() {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const response = await axios.get('/insights/list', {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            brand: brand.id,
        },
    });
    return response.data;
}
